// opervex-frontend/src/components/ToastAlert/index.js

import { Component } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import DOMPurify from "dompurify";
import ToastService from "../../services/ToastService";

class ToastAlert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toasts: [],
    };
  }

  componentDidMount() {
    ToastService.register((toast) => {
      this.setState((prevState) => ({
        toasts: [...prevState.toasts, toast],
      }));

      setTimeout(() => {
        this.setState((prevState) => ({
          toasts: prevState.toasts.filter((t) => t.id !== toast.id),
        }));
      }, toast.duration || 5000);
    });
  }

  getIcon(variant) {
    switch (variant) {
      case "success":
        return "✔️";
      case "danger":
        return "❌";
      case "warning":
        return "⚠️";
      case "info":
        return "ℹ️";
      default:
        return "🔔";
    }
  }

  render() {
    return (
      <ToastContainer position="top-end" className="p-4">
        {this.state.toasts.map((toast) => (
          <Toast
            key={toast.id}
            className={`custom-toast toast-${toast.variant}`}
            bg="light"
            onClose={() =>
              this.setState((prevState) => ({
                toasts: prevState.toasts.filter((t) => t.id !== toast.id),
              }))
            }
            show
            autohide
            delay={toast.duration || 5000}
          >
            <Toast.Header>
              <span style={{ marginRight: 8 }}>{this.getIcon(toast.variant)}</span>
              <strong className="me-auto">{toast.title}</strong>
            </Toast.Header>

            <Toast.Body>
              {Array.isArray(toast.messages) ? (
                toast.messages.map((message, index) => (
                  <div
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(typeof message === "string" ? message : message?.message),
                    }}
                  />
                ))
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(toast.messages),
                  }}
                />
              )}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    );
  }
}

export default ToastAlert;
